import { formatDate } from '../../lib/calendar';
import { FieldRow } from '../FieldSheet';
import { Sheet, SheetButton } from '../Sheet';
import type { ProjectDetail, DateEdit } from './types';
/** Shoot / edit as one sheet: first day, then the optional last day with its
    own Clear — the mockup's "second field on the same sheet" (§6.2 note D),
    stacked rather than crammed into the calendar sheet. */
function RangeSheet({
  which,
  project,
  onClose,
  openDate,
  patch,
}: {
  which: 'shoot' | 'edit';
  project: ProjectDetail;
  onClose: () => void;
  openDate: (edit: DateEdit) => void;
  patch: (fields: Record<string, unknown>) => Promise<void>;
}) {
  const label = which === 'shoot' ? 'Shoot' : 'Edit';
  const startField = which === 'shoot' ? 'shoot_date' : 'edit_date';
  const endField = which === 'shoot' ? 'shoot_end_date' : 'edit_end_date';
  const start = project[startField];
  const end = project[endField];

  return (
    <Sheet
      open
      onClose={onClose}
      variant="half"
      title={`${label} dates`}
      context={project.name}
      rightAction={<SheetButton onClick={onClose}>Done</SheetButton>}
    >
      <FieldRow
        label="First day"
        mono
        value={formatDate(start)}
        empty={!start}
        onPress={() =>
          openDate({
            title: `First day of the ${label.toLowerCase()}`,
            context: project.name,
            value: start,
            allowClear: true,
            onPick: (iso) => void patch({ [startField]: iso }),
          })
        }
      />
      {start && (
        <FieldRow
          label="Last day"
          mono
          value={formatDate(end)}
          empty={!end}
          onPress={() =>
            openDate({
              title: `Last day of the ${label.toLowerCase()}`,
              context: project.name,
              value: end,
              seed: start,
              allowClear: true,
              onPick: (iso) => void patch({ [endField]: iso }),
            })
          }
        />
      )}
    </Sheet>
  );
}


export { RangeSheet };
